import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Constants} from "./utils/constants";
import {MyStorageService} from "./services/my-storage.service";
import {RestaurantService} from "./services/restaurant.service";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Restaurant - app';

  constructor(
    public translate: TranslateService,
    private restaurantService:RestaurantService,
    private myStorageService: MyStorageService,
  ) {
    this.translate.addLangs(Constants.SYSTEM_LANGUAGES);
    this.translate.setDefaultLang(Constants.DEFAULT_LANGUAGE);
    this.restaurantService.storeUsersRestaurants()
  }

  ngOnInit(): void {
    let storedLang = this.myStorageService.getFromCookies(Constants.STORAGE_KEYS.LANGUAGE, Constants.DEFAULT_LANGUAGE);
    this.translate.use(storedLang);
  }

}
